import { render, staticRenderFns } from "./AvatarList.vue?vue&type=template&id=490f7bee&scoped=true"
import script from "./AvatarList.vue?vue&type=script&lang=js"
export * from "./AvatarList.vue?vue&type=script&lang=js"
import style0 from "./AvatarList.vue?vue&type=style&index=0&id=490f7bee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490f7bee",
  null
  
)

export default component.exports